import React, { Fragment, useState } from 'react'
import estilos from '../Zonas/ZonasListComponent.module.css'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

import AsociadosDeLaLocalidadListComponent from './AsociadosDeLaLocalidadListComponent'
import MapaComponent from './MapaComponent'
import SublocalidadFormComponent from './SublocalidadFormComponent';


function AsociadosDeLaLocalidadComponent(props) {

    const localidad = props.localidad
    const sublocalidad = props.sublocalidad
    const zona = props.zona
    const asociados = props.asociados

    const dispatch = useDispatch()

    const [sublocalidadModify, setsublocalidadModify] = React.useState(null)

    const [modalAnadirSublocalidad, setOpenModalAnadirSublocalidad] = React.useState(false);
    const handleOpenModalAnadirSublocalidad = () => setOpenModalAnadirSublocalidad(true);

    const handleCloseModalAnadirSublocalidad = () => {
        setOpenModalAnadirSublocalidad(false);
        setsublocalidadModify(null)
        dispatch(getLocalidadesByZona(zona.idzona))
    }

    const handleEditarAnadirSublocalidad = (sublocalidad) => {
        handleOpenModalAnadirSublocalidad()
        setsublocalidadModify(sublocalidad)
        dispatch(getLocalidadesByZona(zona.idzona))
    }

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1500, bgcolor: 'background.paper',
        border: '2px solid #000', boxShadow: 24, p: 4, overflow: 'scroll', height: '90%',
    };


    const HTMLmodalAnadirSublocalidades = () => {
        return (
            <Modal
                open={modalAnadirSublocalidad}
                onClose={handleCloseModalAnadirSublocalidad}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <SublocalidadFormComponent localidad={localidad} sublocalidadModify={sublocalidadModify}></SublocalidadFormComponent>
                </Box>
            </Modal >
        )
    }

    return (
        <Fragment><br />
            <div className='row'>
                <div className='col-12' style={{ textAlign: 'center' }}>
                    <h3 className={`${estilos.tituloForm}`}>Lista de Asociados y sus instalaciones de la Zona <strong>{zona.nombrezona}</strong></h3>
                </div>
                
                <div className={`row text-center mt-2`}>
                    <div className='row'>
                        <div className='col-7'>
                            <h1 className={`${estilos.tituloForm}`}></h1>
                        </div>
                    </div>
                    <div className='row' >
                        <div className='col' style={{ textAlign: 'left' }}>
                            {/* <h4>de {localidad.nombrelocalidad} en {zona.nombrezona}</h4> */}
                            <hr />

                            {/*  <MapaComponent asociados={''} lat={localidad.lat} lng={localidad.lng} zoom={10} tipo={2}></MapaComponent>*/}
                            <div className='col' style={{ textAlign: 'center' }} >
                                {<AsociadosDeLaLocalidadListComponent actualizarZonas={props.actualizarZonas} asociados={zona.asociadosenlalocalidad} zona={props.zona} handleCloseModalAsociados={props.handleCloseModalAsociados}></AsociadosDeLaLocalidadListComponent>}
                            </div>
                        </div>

                    </div>


                </div>
            </div>
            {HTMLmodalAnadirSublocalidades()}
        </Fragment>
    )
}

export default AsociadosDeLaLocalidadComponent